import React, { useState } from 'react';
import Grid from '@mui/material/Grid';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import { Button, Card, CardContent, Tooltip } from '@mui/material';
import TopScreenAlert from 'components/TopScreenAlert';
import { useDependencyInjection } from 'hooks/useDependencyInjection';
import DeleteButton from './DeleteButton';
import CancelButton from './CancelButton';
import SaveButton from './SaveButton';

export default function ButtonGroup({
  isVisibleCancelButton = true,
  ...props
}) {
  const [openDialogError, setOpenDialogError] = useState(false);
  const [message, setMessage] = useState('');

  const { history, error, success, api } = useDependencyInjection();

  const handleClickDel = async () => {
    try {
      await api.delete(props.deleteRoute + props.id).then(() => {
        success();
        history.goBack();
      });
    } catch (err) {
      error(err.response.data.message);
    }
  };

  return (
    <div>
      {props.messageDialogError ? (
        <Dialog
          open={openDialogError}
          onClose={() => {
            history.push('/signin');
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {message !== ''
              ? message
              : 'Erro ao submeter ação! Tente novamente.'}
          </DialogTitle>
          <DialogActions>
            <Button
              onClick={() => setOpenDialogError(false)}
              color="primary"
              size="large"
            >
              Entendi
            </Button>
          </DialogActions>
        </Dialog>
      ) : null}
      <Card
        sx={{
          padding: '0px',
          border: '1px solid #BFC9C2',
          borderRadius: '16px',
          background: '#F8FAF6',
          boxShadow: 'none',
          margin: '16px',
          marginTop: '24px',
        }}
      >
        <CardContent>
          <Grid
            container
            direction="row"
            justifyContent="flex-end"
            alignItems="flex-end"
            spacing={2}
            padding="16px"
          >
            {isVisibleCancelButton && (
              <Grid item>
                <CancelButton
                  disabled={props.disable}
                  onClickCancel={() => history.goBack()}
                />
              </Grid>
            )}
            {props.id != null && (
              <Grid item>
                {(props.disable || props.disableTemporary) &&
                props.displayTooltip ? (
                  <Tooltip title="O viveiro que foi incluído em um ciclo não pode ser excluído.">
                    <div>
                      <DeleteButton
                        dialogMessage={props.message}
                        disabled={props.disable || props.disableTemporary}
                        onClickDelete={handleClickDel}
                      />
                    </div>
                  </Tooltip>
                ) : (
                  <DeleteButton
                    dialogMessage={props.message}
                    disabled={props.disable || props.disableTemporary}
                    onClickDelete={handleClickDel}
                  />
                )}
              </Grid>
            )}
            <Grid item>
              {props.sendEmail || <SaveButton disabled={props.disable} />}
            </Grid>

            {props.alert && openDialogError ? (
              <TopScreenAlert message={message} />
            ) : null}
          </Grid>
        </CardContent>
      </Card>
    </div>
  );
}
